var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-layout',{attrs:{"add-class":"type-b"}},[_c('popup-change-group-delivery',{attrs:{"group-list":_vm.groupList},on:{"dispose":_vm.onDispose,"ok":_vm.onDeliveryList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720db89c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-popups/ModalChangeGroupDelivery.vue
// module id = null
// module chunks = 